export const dayWorkingHours = 8;

export const ioType = {
    enter: 1,
    exit: 2
}

export const themeType = {
    light: 'light',
    dark: 'dark'
}

export const themeTypeAction = {
    get: 'get',
    set: 'set'
}


export const defaultGuid = "00000000-0000-0000-0000-000000000000";

export const timeDefaultValue = "00:00";
export const timeShortDefaultValue = "0:0";
export const teleworkingStartTime = "06:59"
export const teleworkingEndTime = "07:00"

export const dayPart = {
    morning: 'morning',
    night: 'night'
}

export const vacationType = {
    'DailyEntitledLeave': 11002,        // مرخصی استحقاقی روزانه
    'DailySickLongLeave': 60006,        // مرخصی استعلاجي بلند مدت
    'MariageLeave': 11064,              // ازدواج
    'DailySickLeave': 11012,            // مرخصی استعلاجي روزانه
    'DailyPaymentLessLeave': 11042,     // مرخصی روزانه بدون حقوق
    'DailyRelativeDeathLeave': 11066,   // مرخصی روزانه فوت اقوام
    'MaternityLeave': 11056,            // مرخصی زايمان
    'EmergencyLeave': 60051,            // مرخصی اضطراری
 
}

export const personnelPhotoStandards = {
    fileType: '.jpg,.jpeg',             // فورمت قابل قبول عکس پرسنل
    height: 640,                        // طول عکس
    width:480,                          // عرض عکس
    dpi: 300,                           // dot per inch 
    size:1024,                          // سایز عکس
    lastCreatedDays: 180                 // آخرین تاریخ ایجاد عکس
}

export const offType = {
    HR: "HR",      //ساعتی 
    ES: "ES",      //استحقاقی
    SK: "SK",      //بیماری
    SKWP: "SKWP",  //بیماری بدون پرداخت
    WP: "WP",      //بدون حقوق
    EZ: "EZ",      //اضطراری
    ESMI: "ESMI"  //استحقاقی ماموریت
}

export const videoFormats = () => {
    return [
        'video/mp4', '.mp4', 
        'video/x-sgi-movie', '.movie', 
        'video/mpeg', '.mpeg', 
        'video/mpeg', '.mpg', 
        'video/vnd.mpegurl', '.vnd.mpegurl',
        'video/ogg', '.ogg', 
        'video/webm', '.webm', 
        'video/3gpp', '.3gpp', 
        'video/x-msvideo', '.avi',
        'video/x-flv', '.flv', 
        'video/jpeg', '.jpeg', 
        'video/x-m4v', '.m4v', 
        'video/quicktime', '.mov',
        'video/x-ms-wmv', '.wmv',
        'video/x-matroska', '.mkv',
        'video/3gpp2', '.3g2',
        'video/mp2t', '.ts',
        'video/x-ms-vob', '.vob'
    ]
}

export const imageFormats = () => [
    '.jpg', '.jpeg', '.png', '.gif', '.webp',
    '.bmp', '.svg', '.tiff', '.tif',
    '.heif', '.heic', '.ico', '.avif',
    'jpg', 'jpeg', 'png', 'gif', 'webp',
    'bmp', 'svg', 'tiff', 'tif',
    'heif', 'heic', 'ico', 'avif'

];

export const conferenceModalType = {
    setting: 'setting',
    exemtion: 'exemtion',
    report: 'report'
}

export const operation = {
    add: 'add',
    modify: 'modify',
    remove: 'remove',
    confirm: 'confirm',
    unknown: 'unknown'
}

export const aboutDocumentTypes = {
    englishCatalog: 1,
    persianCatalog: 2,
    companyProfile: 3,
    companyIntroduction: 4,
    qualityPolicy: 5,
    healthSafetyandEnvironmentPolicy: 6,
    visionAndMissionStatement: 7,
    valuesStatement: 8,
    keyProcessDiagram: 9,
    ethicalAndCollaborationCharter: 10,
    certificates: 11,
    slides: 12,
}

export const restTypes = {
    dailyEarnedLeave: 'DailyEarnedLeave',
    hourlyLeave: 'HourlyLeave',
    dailySickLeave: "SickLeave"
}

export const defaultWorkingMinuteTime = {
    zero: 0,
    teleworking: 480
}

export const conferenceMessages = {
    permissionDenied: 'شما مجاز به استفاده از این قسمت برنامه نیستید.'
}

export const persianDayPart = {
    morning: 'صبح',
    evening: 'عصر'
}

export const confirmType = {
    confirmed: 1,
    waiting: 2
}

export const annualRestHour = {
    value: 208,
    sendToNewYear: 96
}

export const timesheetSummeryItems = {
    basic: 'basic',
    overtime: 'overtime',
    mission: 'mission',
    homework: 'homework'
}

export const dateFormat = {
    jalali: 'jalali',
    gregorian: 'gregorian'
}

export const personnelWorkwiseLocation = {
    tehran: 't',
    site: 's'
}

export const personnel = {
    allPersonnel: '00'
};

export const surveyTypes = {
    yesNoQuestion: 1,
    twoOptions: 2
}

export const hourDevision = {
    full: 60,
    half: 30,
    quarter: 15,
}

export const surveyHeaderQuestions = {
    personnelPerspectiveAnalysis: 1,          //فرم نظرسنجی سنجش نگرش کارکنان
    calendarNotebookColorSurvey: 2,           //نظرسنجی رنگ سررسید
    functioningTypeSurvey: 3,                 //نظرسنجی نوع کارکرد    
    qrganizationalCultureQuestionnaire:  4,   //فرم پرسشنامه فرهنگ سازمانی  
    sportSaloonSurvey:  6                     //سالن ورزشی 
}

export const surveyQuestionTypes = {
    yesNo: 1,                                //بله/خیر
    twoOptions: 2,                           //دو گزینه ای
    multiOptionsMultiSelection: 3,           //چند گزینه ای چند انتخابی
    multiOptionsSingleSelection: 4,          //چند گزینه ای تک انتخابی
    description: 5                           //تشریحی
}

export const qhseTypes = {
    rootDirectory: 1
}

export const periodType = {
    daily: 'daily',
    weekly: 'weekly',
    monthly: 'monthly',
    notSet: 'notSet'
};

export const dateType = {
    today: 'today',
    tomorrow: 'tomorrow',
    yesterday: 'yesterday',
    notSet: 'notSet'
};

export const systems = {
    Intranet: 1,
    Erms: 2
}

export const selectAnItem = {
    value: '0',
    label: 'انتخاب کنید ...'
}

export const allPersonnels = {
    value: '00',
    label: 'لیست کلیه پرسنل شرکت'
}

export const timesheetProcessType = {
    Systematic: 0,
    Manual: 1
}

export const siteSecurityServicePersonnelType = {
    Security: "1",
    Site: "2",
    Service: "3",
}

export const siteServiceSecurityConstantsOnServer = {
    SecurityPersonnel: "SecurityPersonnel",
    SitePersonnel: "SitePersonnel",
    ServicePersonnel: "ServicePersonnel",
    AllPersonnel: "AllPersonnel"
}

export const mailSentResult = {
    subject: 'نتیجه تایید عکس پروفایل',
    notAcceptedResult: `متاسفانه عکس پروفایل شما مورد تایید قرار نگرفت. لطفا عکس دیگری را آپلود کنید.`,
    notAcceptedResultByDirectManager: `متاسفانه عکس پروفایل شما از طرف مدیر مستقیم شما مورد تایید قرار نگرفت. لطفا عکس دیگری را آپلود کنید.`,
    notAcceptedResultByHumanResourceManager: `متاسفانه عکس پروفایل شما از طرف مدیر منابع انسانی مورد تایید قرار نگرفت. لطفا عکس دیگری را آپلود کنید.`,
}


export const dataSavedSuccessfully = 'اطلاعات با موفقیت ذخیره گردید.';
export const dataSavedWithError = 'ذخیره اطلاعات با خطا مواجه گردید.';
export const languageAlreadyExists = 'زبان انتخاب شده از قبل وجود دارد.';
export const skillAlreadyExists = 'تخصص انتخاب شده از قبل وجود دارد.';
export const membershipAlreadyExists = 'عضویت انتخاب شده از قبل وجود دارد.';
export const trainingAlreadyExists = 'دوره انتخاب شده از قبل وجود دارد.';
export const publicationAlreadyExists = 'این نشر از قبل وجود دارد.';
export const experienceAlreadyExists = 'این سابقه کاری از قبل وجود دارد.';

export const conferenceSettingAccessDeneid = 'شما مجوز اعمال تغییرات در این قسمت را ندارید!'

export const getPersianMonth = (month) => {
    var months = [
        'Farvardin',
        'Ordibehesht',
        'Khordad',
        'Tir',
        'Mordad',
        'Shahrivar',
        'Mehr',
        'Aban',
        'Azar',
        'Day',
        'Bahman',
        'Esfand'
    ];
    var monthNum = parseInt(month);
    if (monthNum < 0 || monthNum > 11)
        return null;
    else
        return months[month];
}

// export const getPersianMonth = (month) => {
//     var months = [
//         'Farvardin',
//         'Ordibehesht',
//         'Khordad',
//         'Tir',
//         'Mordad',
//         'Shahrivar',
//         'Mehr',
//         'Aban',
//         'Azar',
//         'Day',
//         'Bahman',
//         'Esfand'
//     ];
//     var monthNum = parseInt(month);
//     if (monthNum < 0 || monthNum > 11)
//         return null;
//     else
//         return months[month];
// }

export const getPersianLabeledMonth = (selectedMonth, zeroBased = true) => {
    let months = []; 
    if (zeroBased === true)
        months = [
            'فروردین',
            'اردیبهشت',
            'خرداد',
            'تیر',
            'مرداد',
            'شهریور',
            'مهر',
            'آبان',
            'آذر',
            'دی',
            'بهمن',
            'اسفند'
        ];
    else {
        months[1] =  "فروردین";
        months[2] =  "اردیبهشت";
        months[3] =  "خرداد";
        months[4] =  "تیر";
        months[5] =  "مرداد";
        months[6] =  "شهریور";
        months[7] =  "مهر";
        months[8] =  "آبان";
        months[9] =  "آذر";
        months[10] =  "دی";
        months[11] =  "بهمن";
        months[12] =  "اسفند";
    }
    let monthNum = parseInt(selectedMonth);

    if (zeroBased && (monthNum < 0 || monthNum > 11))
        return null;

    if (!zeroBased && (monthNum < 1 || monthNum > 12))
        return null;

    return months[monthNum];
}

export const persianMonths = (zeroBased = true) => {
    if (zeroBased)
        return [
            { value: 0, label: 'فروردین' },
            { value: 1, label: 'اردیبهشت' },
            { value: 2, label: 'خرداد' },
            { value: 3, label: 'تیر' },
            { value: 4, label: 'مرداد' },
            { value: 5, label: 'شهریور' },
            { value: 6, label: 'مهر' },
            { value: 7, label: 'آبان' },
            { value: 8, label: 'آذر' },
            { value: 9, label: 'دی' },
            { value: 10, label: 'بهمن' },
            { value: 11, label: 'اسفند' },
        ];
    else
        return [
            { value: 1, label: 'فروردین' },
            { value: 2, label: 'اردیبهشت' },
            { value: 3, label: 'خرداد' },
            { value: 4, label: 'تیر' },
            { value: 5, label: 'مرداد' },
            { value: 6, label: 'شهریور' },
            { value: 7, label: 'مهر' },
            { value: 8, label: 'آبان' },
            { value: 9, label: 'آذر' },
            { value: 10, label: 'دی' },
            { value: 11, label: 'بهمن' },
            { value: 12, label: 'اسفند' },
        ];

}

export const getDayNames = () => {
    return [
        {
            key: 'Sat',
            value: 'شنبه'
        },
        {
            key: 'Sun',
            value: 'یکشنبه'
        },
        {
            key: 'Mon',
            value: 'دوشنبه'
        },
        {
            key: 'Tue',
            value: 'سه شنبه'
        },
        {
            key: 'Wed',
            value: 'چهارشنبه'
        },
        {
            key: 'Thu',
            value: 'پنج شنبه'
        },
        {
            key: 'Fri',
            value: 'جمعه'
        },
    ];
}

export const getLatinDayNames = () => {
    return [
        {
            key: 'Sat',
            value: 'Saturday'
        },
        {
            key: 'Sun',
            value: 'Sunday'
        },
        {
            key: 'Mon',
            value: 'Monday'
        },
        {
            key: 'Tue',
            value: 'Tuesday'
        },
        {
            key: 'Wed',
            value: 'Wednsday'
        },
        {
            key: 'Thu',
            value: 'Thursday'
        },
        {
            key: 'Fri',
            value: 'Friday'
        },
    ];
}
// export const TimeTableTytpe = {
//     DailyHourly: 1,
//     WeeklyHourly: 2,
//     DailyHourLess: 3,
//     WeeklyHourLess: 4,
//     MonthlyHourLess: 5,
// }

export const TimeTableDirection = {
    Left: 'left',
    Right: 'right'
}

export const ReportType = {
    None: 'none',
    Administrative: 'Administrative',
    CostCenter: 'CostCenter'
}

export const days = () => { 
    return [
        {value: '1', label: '1'}, {value: '2', label: '2'}, {value: '3', label: '3'}, {value: '4', label: '4'},
        {value: '5', label: '5'}, {value: '6', label: '6'}, {value: '7', label: '7'}, {value: '8', label: '8'},
        {value: '9', label: '9'}, {value: '10', label: '10'}, {value: '11', label: '11'}, {value: '12', label: '12'}, 
        {value: '13', label: '13'}, {value: '14', label: '14'}, {value: '15', label: '15'}, {value: '16', label: '16'}, 
        {value: '17', label: '17'}, {value: '18', label: '18'}, {value: '19', label: '19'}, {value: '20', label: '20'}, 
        {value: '21', label: '21'}, {value: '22', label: '22'}, {value: '23', label: '23'}, {value: '24', label: '24'}, 
        {value: '25', label: '25'}, {value: '26', label: '26'}, {value: '27', label: '27'}, {value: '28', label: '28'}, 
        {value: '29', label: '29'}, {value: '30', label: '30'}, {value: '31', label: '31'}
    ]
}

export const persianMonth = () =>  {
    return [
        {value: '1', label: 'فروردین'}, {value: '2', label: 'اردیبهشت'}, {value: '3', label: 'خرداد'},
        {value: '4', label: 'تیر'}, {value: '5', label: 'مرداد'}, {value: '6', label: 'شهریور'},
        {value: '7', label: 'مهر'}, {value: '8', label: 'آبان'}, {value: '9', label: 'آذر'},
        {value: '10', label: 'دی'}, {value: '11', label: 'بهمن'}, {value: '12', label: 'اسفند'}
    ]
}

export const gregorianMonth = () => {
    return [
        {value: '1', label: 'January'}, {value: '2', label: 'February'}, {value: '3', label: 'March'},
        {value: '4', label: 'April'}, {value: '5', label: 'May'}, {value: '6', label: 'Jun'},
        {value: '7', label: 'July'}, {value: '8', label: 'Augest'}, {value: '9', label: 'September'},
        {value: '10', label: 'October'}, {value: '11', label: 'November'}, {value: '12', label: 'December'}
    ]
}

export const persianYears = () =>  {
    return [
        {value: '1399', label: '1399'}, {value: '1400', label: '1400'}, {value: '1401', label: '1401'},
        {value: '1402', label: '1402'}, {value: '1403', label: '1403'}, {value: '1404', label: '1404'},
        {value: '1405', label: '1405'}, {value: '1406', label: '1406'}, {value: '1407', label: '1407'},
        {value: '1408', label: '1408'}, {value: '1409', label: '1409'}, {value: '1410', label: '1410'}
    ]
}

export const gregorianYears = () =>  {
    return [
        {value: '2020', label: '2020'}, {value: '2021', label: '2021'}, {value: '2022', label: '2022'},
        {value: '2023', label: '2023'}, {value: '2024', label: '2024'}, {value: '2025', label: '2025'},
        {value: '2026', label: '2026'}, {value: '2027', label: '2027'}, {value: '2028', label: '2028'},
        {value: '2029', label: '2029'}, {value: '2030', label: '2030'}
    ]
}

export const scheduleMonthlyRow = 7;
export const scheduleMonthlyCol = 5;


export const costCenterOff = 'off';
export const dailyMission = 'gge00';
export const offActivity = 'ge';
export const zeroNumber = 0;
export const zeroTime = "00:00";
export const application = {
    INFOBOARD: 10,
    USER_ADDRESS: 14
} 

export const offDayCheck = "OFF_DAY_CHECK"

export const seenType = {
    OPEN: 1,
    DOWNLOADED: 2
} 

export const chatPageAddress = '/Public/Chat/';

export const userType = {
    administrator: "Admin",
    powerUser: "Power User",
    user: "User"
}

export const conferenceHallRoles = {
    TheNumberOfVisibleAppointmentsInDays: 'The Number of Visible Appointments In Days'
}

